export default __webpack_public_path__ + "static/media/valdo-logo.4d1fae19.png";